import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "close-button-bl"
}
const _hoisted_2 = {
  key: 1,
  style: {"position":"fixed","top":"0","left":"0","right":"0","bottom":"0","height":"100%","width":"100%"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-4 ms-4 text-start fw-bold fs-2" }, " Coldplay Booklets Unlocked! Tap The Album Cover to View ", -1)
const _hoisted_6 = { class: "col-md-12 ms-4 text-start" }
const _hoisted_7 = {
  class: "m-4 mt-2 g-4 row images-container",
  style: {"background-image":"url('/images/bg.png')"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]

import {ref} from "vue";
import {onMounted} from "vue";
import {onUnmounted} from "vue";

interface IImage {
  img: string;
  link: string
}

interface IImages {
  [a: string]: IImage
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const isInFullScreen = ref(false)
const handleFullScreenChange = () => {
  isInFullScreen.value = !!document.fullscreenElement
  if (isInFullScreen.value) {
    document.body.style.overflow = 'auto'
  }
}

onMounted(() => {
  addEventListener("fullscreenchange", handleFullScreenChange);
})

onUnmounted(() => {
  removeEventListener("fullscreenchange", handleFullScreenChange);
})

function toggleFullscreen() {
  let elem = document.body;


  const fn = elem.requestFullscreen || elem.webkitRequestFullscreen

  if (!fn) {
    alert('Fullscreen not supported on this device')
    return;
  }

  if (!document.fullscreenElement) {
    fn.call(elem)
        .catch((err) => {
          alert(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
        });
  } else {
    document.exitFullscreen();
  }
}

const titleImg = '20230220092202_00002A.jpg'
const titleImg2 = '20230306152648_00001A.jpg'

const slug1 = 'magazine_1_pdfs'
const slug2 = 'mag_14_pdf'

const links = [
  "https://e.issuu.com/embed.html?d=ahfod_album_booklet&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=arobtth_album_booklet&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=everyday_life_album_booklet&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=ghost_stories_album_booklet&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=mots_album_booklet&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=mylo_album_booklets&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=parachutes_album_booklet&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=viva_album_booklet&hideIssuuLogo=true&u=interactiveimages",
  "https://e.issuu.com/embed.html?d=x_y_album_booklet&hideIssuuLogo=true&u=interactiveimages",
]

const images: IImages = {
  '13': {
    img: 'img1.png',
    link: 'mag_2_post_it_pages',
  },
  '19': {
    img: 'img1.png',
    link: 'mag_8_pdf',
  },
  '33': {
    img: 'img1.png',
    link: 'magazine_6',
  },
  '34': {
    img: 'img1.png',
    link: 'mag_7_pdf',
  },
  '42': {
    img: 'img1.png',
    link: 'mag_9',
  },
  '48': {
    img: 'img1.png',
    link: 'https://issuu.com/home/published#:~:text=Bong%2048,Mar%2022nd%2C%202023',
  },
  '49': {
    img: 'img1.png',
    link: 'magazine_5_pdf-merged',
  },
  '52': {
    img: 'img1.png',
    link: 'mag_3_pdf',
  },
  '20': {
    img: 'img1.png',
    link: 'mag_10_pdf',
  },
  '21': {
    img: 'img1.png',
    link: 'mag_11_pdf',
  },
  '37': {
    img: '20230306151354_00001A.jpg',
    link: 'mag_12_pdf',
  },
  '29': {
    img: '20230306151835_00001A.jpg',
    link: 'mag_13',
  },
  '46': {
    img: '20230307102629_00001A.jpg',
    link: 'mag_15_pdf',
  },
  '40': {
    img: '20230307110814_00001A.jpg',
    link: 'mag_16',
  },
  '41': {
    img: '20230307111817_00001A.jpg',
    link: 'mag_17',
  },
  '17': {
    img: '20230307121615_00001A.jpg',
    link: 'mag_18',
  },
}

const slug = ref('')
const iframeVisible = ref(false)
const showIframe = (linkIndex: number) => {
  // if (newSlug === 'start1') {
  //   slug.value = slug1;
  // } else if (newSlug === 'start2') {
  //   slug.value = slug2;
  // } else {
  //   slug.value = images[newSlug].link
  // }

  slug.value = links[linkIndex]

  document.body.style.overflow = 'hidden'
  const metaElement1 = document.head.querySelector('meta[name=viewport]')
  metaElement1 && metaElement1.setAttribute('name', 'viewport_def')

  const metaElement2 = document.head.querySelector('meta[name=viewport_for_iframe]')
  metaElement2 && metaElement2.setAttribute('name', 'viewport')
  iframeVisible.value = true
}

const closeIframe = () => {
  document.body.style.overflow = ''
  iframeVisible.value = false

  const metaElement2 = document.head.querySelector('meta[name=viewport]')
  metaElement2 && metaElement2.setAttribute('name', 'viewport_for_iframe')

  const metaElement1 = document.head.querySelector('meta[name=viewport_def]')
  metaElement1 && metaElement1.setAttribute('name', 'viewport')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (iframeVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", { onClick: closeIframe }, " Close ")
        ]))
      : _createCommentVNode("", true),
    (iframeVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("iframe", {
            allow: "clipboard-write",
            sandbox: "allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms",
            allowfullscreen: "true",
            style: {"position":"absolute","border":"none","width":"100%","height":"100%","left":"0","right":"0","top":"0","bottom":"0"},
            src: slug.value
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (false && !isInFullScreen.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleFullscreen()), ["prevent"])),
              href: "#"
            }, "enter full screen "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, index) => {
        return _createElementVNode("div", {
          key: `img-${index}`,
          class: "col-md-4 link-img"
        }, [
          _createElementVNode("a", {
            onClick: _withModifiers(($event: any) => (showIframe(index)), ["prevent"]),
            href: "#"
          }, [
            _createElementVNode("img", {
              src: `/images/img${index+1}.png`,
              alt: ""
            }, null, 8, _hoisted_9)
          ], 8, _hoisted_8)
        ])
      }), 64))
    ])
  ], 64))
}
}

})